import { RoomBaseApiService } from '@/core/service/room.baseapi.service'
import { ErrorWrapper, ResponseWrapper } from '@/core/service/util'

export class RoomCallService extends RoomBaseApiService {

  async getRoomCallInfo() {
    try {
      const response = await this.request().get(
        `/api/v3/room/${this.getRoomId()}/call`
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async changeCallType(params) {
    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/call/changeCallType`,
          params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async enterRoomCall({first}) {
    try {
      const response = await this.request().post(
        `/api/v3/room/${this.getRoomId()}/call/enter?first=${!!first}`
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async requestOffer (param) {
      try {
          const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/call/requestOffer`, param)
          return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          throw new ErrorWrapper(error)
      }
  }

  async sendOffer (param) {
      try {
          const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/call/offer`, param);
          return new ResponseWrapper(response, response.data?.data)
      } catch (error) {
          throw new ErrorWrapper(error)
      }
  }

  async sendAnswer(param) {
    try {
      // const response = await this.request().post(
      //   `/api/v3/room/${this.getRoomId()}/call/answer`,
      //   param
      // )
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/call/answer`,
          param
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async sendIcecandidate(param) {
    try {
      // const response = await this.request().post(
      //   `/api/v3/room/${this.getRoomId()}/call/icecandidate`,
      //   param
      // )
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/call/icecandidate`,
          param
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async sendSignalStable(params) {
    try {
      // const response = await this.request().post(
      //   `/api/v3/room/${this.getRoomId()}/call/signalStable`,
      //   params
      // )
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/call/signalStable`,
          params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async changeUserVideoSenderMaxBitrate(params) {
    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/call/changeUserVideoSenderMaxBitrate`,
          params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async startScreenShare(params) {

    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/call/startScreenShare`,
          params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async stopScreenShare(params) {

    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/call/stopScreenShare`,
          params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  async changeVideoQuality(videoQuality) {
    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/call/videoQuality`,
          {videoQuality}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async changeWebinarType(webinarType) {
    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/call/changeWebinarType`,
          {webinarType}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }  
}

export const roomCallService = new RoomCallService()
